export class ReservationModuleConfiguration {
    public id: number;
    public systemId: number;
    public locationId: number;
    public reservationsEndTime: number;
    public beforeReservationMins: number;
    public afterReservationMins: number;
    public allowSameDayReservation: boolean;
    public sendReminder: boolean;
    public sendReservationEmail: boolean;
    public additionalReminderText: string;
    public additionalEmailText: string;
    public sendReservationSms: boolean;
    public sendQrCode: boolean;
    public termsTitle: string;
    public terms: string;
    public isRecaptcha: boolean;
    public recaptchaPublicKey: string;
    public recaptchaPrivateKey: string;
    public reservationAddress: string;
    public supportsWcag: boolean;
    public supportsCsvImport: boolean;
    public supportsCsvExport: boolean;
    public twoStepVerification: boolean;
    public removeUnconfirmedMins: number;
    public alwaysActive: boolean;
    public startHour: number;
    public endHour: number;
}
